/**
 * 超级菜单修复 - 解决二级菜单点击问题
 */
(function() {
  // 等待DOM加载完成
  document.addEventListener('DOMContentLoaded', function() {
    // 修复超级菜单中二级菜单点击问题
    function fixMegaMenuClickIssue() {
      // 为二级菜单的标题添加点击事件处理
      document.querySelectorAll('.dropdown-megamenu .col h6').forEach(function(h6) {
        h6.addEventListener('click', function(event) {
          // 阻止事件冒泡到父元素
          event.stopPropagation();
        });
      });
      
      // 确保三级菜单项点击时不会触发父级菜单的点击事件
      document.querySelectorAll('.dropdown-megamenu .dropdown-item').forEach(function(item) {
        item.addEventListener('click', function(event) {
          // 阻止事件冒泡，使链接正常工作
          event.stopPropagation();
        });
      });
      
      // 为移动端菜单添加类似的修复
      document.querySelectorAll('#offcanvas-menu-nav .nav-link').forEach(function(navLink) {
        navLink.addEventListener('click', function(event) {
          // 如果链接有href属性并且不是#开头，允许正常导航
          if (this.getAttribute('href') && !this.getAttribute('href').startsWith('#')) {
            // 允许正常导航
          } else if (this.getAttribute('data-bs-toggle') === 'collapse') {
            // 这是折叠菜单，保留默认行为
          } else {
            // 其他情况，阻止冒泡
            event.stopPropagation();
          }
        });
      });
    }

    // 执行修复
    fixMegaMenuClickIssue();
    
    // 监听动态加载的内容
    document.addEventListener('shopify:section:load', function() {
      fixMegaMenuClickIssue();
    });
  });
})(); 